<div class="billing-new-details-main">
    <div class="row">
        <div class="col no-padding-right no-padding-top">
            <ng-container *ngIf="isAcmic; else maStateBackbtn">
                <mapfre-button
                    additionalClasses="link-button blue-color-link top-information no-padding font-weight-normal"
                    [backIcon]="'assets/img/icons/back-arrow-blue.svg'" [iconClasses]="'align-middle pr-1'"
                    [showIconsCustom]="true" routerLink="/billing-new/billing-landing"> {{ 'Back' | translate }}
                </mapfre-button>
            </ng-container>
            <ng-template #maStateBackbtn>
                <mapfre-button
                    additionalClasses="link-button red-link top-information no-padding button-border-red font-weight-500"
                    [backIcon]="'assets/img/icons/back-arrow-red.png'" [iconClasses]="'align-middle pr-1'"
                    [showIconsCustom]="true" routerLink="/billing-new/billing-landing"> {{ 'BACK' | translate }}
                </mapfre-button>
            </ng-template>

        </div>
    </div>
    
    <div class="billing-new-header">
        <div class="bn-back-action">

        </div>
        <div class="w-100" *ngIf="billingPolicyData?.policyData?.length">
            <app-billing-details-header [billingPolicyData]="billingPolicyData"
                (selectPolicy)="onPolicySelect($event)"></app-billing-details-header>
        </div>
    </div>
    <div class="billing-navs">
        <nav class="billing-details-nav">
            <a routerLinkActive="active" class="billing-nav-tab {{activeClass}} overview" routerLink="/billing-new/{{ policyNumber }}/details"
                title="{{ 'BILLING' | translate }}">{{ "Overview" | translate }}</a>

            <a class="billing-nav-tab" routerLinkActive="active"
                routerLink="/billing-new/{{ policyNumber }}/make-a-payment"
                title="{{ 'POLICY_OVERVIEW' | translate }}">{{ "Make a payment" | translate }}</a>
            <a class="billing-nav-tab document" routerLinkActive="active" routerLink="/billing-new/{{ policyNumber }}/documents"
                title="{{ 'DOCUMENTS' | translate }} ">{{ "DOCUMENTS" | translate }}</a>
        </nav>
        <div class="empty-nav-div"></div>
    </div>
    <div class="bn-inner-section">
        <div class="w-100">
            <ng-container *ngIf="policy">
                <app-bn-tab-header [policy]="policy" [hideTerm]="policy?.pifDiscountInfo?.pifEligible || policy?.isUnderRenewal">
                </app-bn-tab-header>
                <app-bn-overview [policy]="policy"></app-bn-overview>
                <ng-container *ngIf="(policy?.policynumber.policyNumber.length === 10 || policy?.policynumber.policyNumber.length === 6) && policy?.policyStatus === 'ACTIVE'">
                <app-billing-cost-breakdown-new [policy]="policy"></app-billing-cost-breakdown-new>
                </ng-container>
                <ng-container *ngIf="policy?.policynumber.policyNumber.length === 10; else as400Policy">
                    <app-bn-transaction-history [policy]="policy"></app-bn-transaction-history>
                </ng-container>
                <ng-template #as400Policy>
                    <app-bn-as-fourhundred-policy [policy]="policy"></app-bn-as-fourhundred-policy>
                </ng-template>
            </ng-container>
            <app-billing-assistance-cards [company]="company" [isAcmic]="isAcmic"
                [policyNumber]="policyNumber"></app-billing-assistance-cards>
        </div>
    </div>
</div>